// Imports Icons
import HandyManServicesIcon from "../assets/landing/handyman-services.svg";
import HomeServiceIcon from "../assets/landing/homeService.svg";
import PersonalAssistIcon from "../assets/landing/moving.svg";
import TailorIcon from "../assets/landing/Tailor.svg";
import PhotographerIcon from "../assets/landing/photographer.svg";
import GradeningIcon from "../assets/landing/Gardening.svg";
import PaintingIcon from "../assets/landing/Painting.svg";
import handymanIcon from "../assets/landing/handyman.svg"
import electricityIcon from "../assets/landing/electricity.svg"


export const FORM_MODES = {
  VIEW: "view",
  EDIT: "edit",
  ADD: "add",
};

// INFO: User Roles
export const roles = {
  USER: "USER",
  TASKER: "TASKER",
};

export const revitionStatus = {
  ACTIVE: "ACTIVE",
  COMPLETED: "COMPLETED",
};

export const paymentHistoryTypes = {
  PAYMENT: "PAYMENT",
  PAYOUT: "PAYOUT"
}

// INFO: User Roles For Dropdown
export const rolesForDropdown = [
  { label: "Client", id: "USER" },
  { label: "Service Provider", id: "TASKER" },
];

export const firebaseUplaodFolders = {
  F_ID_IMAGES: "idimages",
  F_OFFERS: "offers",
  F_ORDERS: "orders",
  F_PROFILE_PICTURES: "profilepictures",
  F_COMPLAINTS: "complaints",
  F_ISSUES: "issues",
  F_MESSAGES: "messages",
  F_MESSAGES_ATTACHMENTS: "message_attachments",
  F_REFERENCES: "references",  
  F_JOB_POSTS: "jobposts",
  F_ADDRESS_PROOF: "addressproof",
}

// INFO: order states
export const orderStatus = {
  ORDER_IN_PROGRESS: "ORDER_IN_PROGRESS",
  ORDER_DELIVERED: "ORDER_DELIVERED",
  IN_REVISION: "IN_REVISION",
  COMPLETED: "COMPLETED",
  COMPLAINT_RAISED: "COMPLAINT_RAISED",
  COMPLAINT_RESOLVED: "COMPLAINT_RESOLVED",
  ISSUE_RAISED: "ISSUE_RAISED",
  ISSUE_RESOLVED: "ISSUE_RESOLVED",
};

export const IGNORED_STATUSES = {
  USER: [orderStatus.ISSUE_RAISED, orderStatus.ISSUE_RESOLVED],
  TASKER: [orderStatus.COMPLAINT_RAISED, orderStatus.COMPLAINT_RESOLVED]
}

export const orderStatusDescription = {
  ORDER_IN_PROGRESS: {
    TASKER: "You are actively working on the assigned Job. Please deliver the completed Job once ready.",
    USER: "The Service Provider is actively working on the assigned task. Please wait for the next update.",
  },
  ORDER_DELIVERED: {
    TASKER: "The Job has been delivered. Wait for the client to review and accept or request a revision.",
    USER: "Service Provider has marked the task as delivered."
  },
  IN_REVISION: {
    TASKER: "Revising the Job based on client feedback. Deliver the revised Job once done.",
    USER: "The Service Provider is revising the task based on your feedback."
  },
  COMPLETED: {
    TASKER: "This Job has been successfully completed. Please leave a review or raise a complaint if necessary.",
    USER: "This Job has been successfully completed. Please leave a review or raise a complaint if necessary."
  },
  COMPLAINT_RAISED: {
    TASKER: "A complaint has been raised for this task. The admin will address the issue shortly.",
    USER: "A complaint has been raised for this task. The admin will address the issue shortly."
  },
  COMPLAINT_RESOLVED: {
    TASKER: "The complaint has been resolved. Thank you for your patience.",
    USER: "The complaint has been resolved. Thank you for your patience."
  },
  ISSUE_RAISED: {
    TASKER: "A issue has been raised for this job. The admin will address the issue shortly.",
    USER: "A issue has been raised for this job. The admin will address the issue shortly."
  },
  ISSUE_RESOLVED: {
    TASKER: "The issue has been resolved. Thank you for your patience.",
    USER: "The issue has been resolved. Thank you for your patience."
  }
};

// INFO: offers states
export const offerStatus = {
  PENDING: "PENDING",
  ACCEPTED: "ACCEPTED",
  DECLINED: "DECLINED",
  CANCELLED: "CANCELLED",
};

// INFO: message types
export const messageTypes = {
  OFFER: "OFFER",
  OFFER_ACTION: "OFFER_ACTION",
  TEXT: "TEXT",
}

// INFO: offer action messages
export const offerActionMessages = {
  ACCEPTED: "Offer has been accepted",
  DECLINED: "Offer has been declined"
}

export const orderStatusForDropdown = [
  { label: "Order In Progress", id: "ORDER_IN_PROGRESS" },
  { label: "Delivered", id: "ORDER_DELIVERED" },
  { label: "Completed", id: "COMPLETED" },
  { label: "Complaint Raised", id: "COMPLAINT_RAISED" },
  { label: "Resolved", id: "COMPLAINT_RESOLVED" },
  { label: "In Revision", id: "IN_REVISION" },
  { label: "Issue Raised", id: "ISSUE_RAISED" },
  { label: "Issue Resolved", id: "ISSUE_RESOLVED" },
];

export const referencesFormats = {
  JPEG_JPG: { mime: "image/jpeg", extensions: [".jpeg", ".jpg"] },
  PNG: { mime: "image/png", extensions: [".png"] },
  PDF: { mime: "application/pdf", extensions: [".pdf"] },
  DOC: { mime: "application/msword", extensions: [".doc"] },
  DOCX: {
    mime: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    extensions: [".docx"],
  },
  XLSX: {
    mime: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    extensions: [".xlsx"],
  },
  PPTX: {
    mime: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    extensions: [".pptx"],
  },
  CSV: { mime: "text/csv", extensions: [".csv"] },
  TXT: { mime: "text/plain", extensions: [".txt"] },
  ZIP: { mime: "application/zip", extensions: [".zip"] },
  RAR: { mime: "application/vnd.rar", extensions: [".rar"] },
};

export const maximumImagesUploadingSizes = {
  size_300KB : 0.3, // 300KB
  size_450KB : 0.45, // 300KB
  size_1MB : 1 // 300KB
}

// NOTE: old >>>>>>>>>>>>
// export const categories = [
//   {
//     _id: "1",
//     name: "General Handyman Services",
//     skills: [
//       { _id: "11", name: "Furniture Assembly" },
//       { _id: "12", name: "Hanging Pictures and Shelves" },
//       { _id: "13", name: "Door Repair" },
//       { _id: "14", name: "Lock Replacement" },
//       { _id: "15", name: "Basic Carpentry Work" },
//       { _id: "16", name: "Window Repair" },
//       { _id: "17", name: "Curtain and Blinds Installation" },
//     ],
//     icon: HandyManServicesIcon,
//     primary: true
//   },
//   {
//     _id: "2",
//     name: "Home Service",
//     skills: [
//       {
//         _id: "21",
//         name: "Home Repairs (minor fixes, patching, plumbing, etc.)",
//       },
//       { _id: "22", name: "Moving Help" },
//       { _id: "23", name: "Home Organization (closet, kitchen, etc.)" },
//       { _id: "24", name: "Appliance Installation and Repairs" },
//       { _id: "25", name: "Pest Control Assistance" },
//     ],
//   },
//   {
//     _id: "3",
//     name: "Plumbing Services",
//     skills: [
//       { _id: "31", name: "Fixing Leaks and Drips" },
//       { _id: "32", name: "Installing Faucets and Showerheads" },
//       { _id: "33", name: "Clearing Clogged Drains" },
//       { _id: "34", name: "Toilet Repair and Installation" },
//       { _id: "35", name: "Water Heater Maintenance" },
//     ],
//   },
//   {
//     _id: "4",
//     name: "Electrical Services",
//     skills: [
//       { _id: "41", name: "Installing Ceiling Fans" },
//       { _id: "42", name: "Replacing Light Fixtures" },
//       { _id: "43", name: "Electrical Outlet and Switch Repair" },
//       { _id: "44", name: "Installing Security Cameras" },
//       { _id: "45", name: "Setting Up Home Entertainment Systems" },
//     ],
//   },
//   {
//     _id: "5",
//     name: "Painting and Decorating",
//     skills: [
//       { _id: "51", name: "Interior Painting" },
//       { _id: "52", name: "Exterior Painting" },
//       { _id: "53", name: "Wallpaper Installation and Removal" },
//       { _id: "54", name: "Touch-Up Painting" },
//       { _id: "55", name: "Furniture Painting" },
//     ],
//     icon: PaintingIcon,
//     primary: true
//   },
//   {
//     _id: "6",
//     name: "Cleaning Services",
//     skills: [
//       { _id: "61", name: "Deep Cleaning (Kitchens, Bathrooms, etc.)" },
//       { _id: "62", name: "Carpet and Upholstery Cleaning" },
//       { _id: "63", name: "Window Cleaning" },
//       { _id: "64", name: "Post-Renovation Cleanup" },
//       { _id: "65", name: "Garage or Attic Cleaning" },
//     ],
//     icon: HomeServiceIcon,
//     primary: true
//   },
//   {
//     _id: "7",
//     name: "Moving Assistance",
//     skills: [
//       { _id: "71", name: "Packing and Unpacking" },
//       { _id: "72", name: "Loading and Unloading Trucks" },
//       { _id: "73", name: "Furniture Rearrangement" },
//       { _id: "74", name: "Heavy Lifting" },
//     ],
//   },
//   {
//     _id: "8",
//     name: "Outdoor Work",
//     skills: [
//       { _id: "81", name: "Gardening and Landscaping" },
//       { _id: "82", name: "Lawn Mowing and Maintenance" },
//       { _id: "83", name: "Gutter Cleaning" },
//       { _id: "84", name: "Power Washing" },
//       { _id: "85", name: "Fence Repair and Installation" },
//     ],
//   },
//   {
//     _id: "9",
//     name: "Home Renovation Support",
//     skills: [
//       { _id: "91", name: "Tile Installation and Repair" },
//       { _id: "92", name: "Drywall Patching and Repair" },
//       { _id: "93", name: "Cabinet Installation" },
//       { _id: "94", name: "Flooring Installation" },
//       { _id: "95", name: "Demolition Support" },
//     ],
//   },
//   {
//     _id: "10",
//     name: "Personal Assistance",
//     skills: [
//       { _id: "101", name: "Errand Running" },
//       { _id: "102", name: "Personal Shopping" },
//       { _id: "103", name: "Virtual Assistant (scheduling, research)" },
//       { _id: "104", name: "Pet Sitting and Walking" },
//       { _id: "105", name: "Event Assistance (decorating, planning, setup)" },
//     ],
//     icon: PersonalAssistIcon,
//     primary: true
//   },
//   {
//     _id: "11",
//     name: "Delivery Services",
//     skills: [
//       { _id: "111", name: "Grocery Shopping and Delivery" },
//       { _id: "112", name: "Food Pickup and Delivery" },
//       { _id: "113", name: "Courier Services" },
//       { _id: "114", name: "Package Delivery" },
//       { _id: "115", name: "Furniture or Large Item Delivery" },
//     ],
//   },
//   {
//     _id: "12",
//     name: "Office and Business Services",
//     skills: [
//       { _id: "121", name: "Office Cleaning" },
//       { _id: "122", name: "Administrative Support" },
//       { _id: "123", name: "IT Support (computer setup, troubleshooting)" },
//       { _id: "124", name: "Furniture Assembly for Offices" },
//       { _id: "125", name: "Data Entry" },
//       { _id: "126", name: "Business Deliveries" },
//     ],
//   },
//   {
//     _id: "13",
//     name: "Technology Support",
//     skills: [
//       { _id: "131", name: "Computer Setup and Repair" },
//       { _id: "132", name: "WiFi and Network Setup" },
//       { _id: "133", name: "TV Mounting and Home Theater Setup" },
//       { _id: "134", name: "Smartphone Assistance" },
//       { _id: "135", name: "Data Recovery" },
//     ],
//   },
//   {
//     _id: "14",
//     name: "Creative Services",
//     skills: [
//       { _id: "141", name: "Graphic Design" },
//       { _id: "142", name: "Photography and Videography" },
//       { _id: "143", name: "Content Writing" },
//       { _id: "144", name: "Web Design and Development" },
//       { _id: "145", name: "Branding and Marketing Support" },
//     ],
//   },
//   {
//     _id: "15",
//     name: "Events and Parties",
//     skills: [
//       { _id: "151", name: "Catering Assistance" },
//       { _id: "152", name: "Bartending" },
//       { _id: "153", name: "Party Setup and Cleanup" },
//       { _id: "154", name: "Event Staffing" },
//       { _id: "155", name: "Decorations and Design" },
//     ],
//   },
//   {
//     _id: "16",
//     name: "Education and Tutoring",
//     skills: [
//       { _id: "161", name: "Academic Tutoring (Math, Science, etc.)" },
//       { _id: "162", name: "Music Lessons" },
//       { _id: "163", name: "Language Tutoring" },
//       { _id: "164", name: "Test Preparation (SAT, GRE, etc.)" },
//       { _id: "165", name: "Skill-Based Training (e.g., coding, photography)" },
//     ],
//   },
//   {
//     _id: "17",
//     name: "Odd Jobs",
//     skills: [
//       { _id: "171", name: "Junk Removal" },
//       { _id: "172", name: "Heavy Lifting and Moving" },
//       { _id: "173", name: "Mounting (TVs, mirrors, shelves)" },
//       { _id: "174", name: "Snow Removal" },
//       { _id: "175", name: "Car Washing and Detailing" },
//     ],
//   },
//   {
//     _id: "18",
//     name: "Lifestyle Services",
//     skills: [
//       { _id: "181", name: "Interior Decorating" },
//       { _id: "182", name: "Fitness Training" },
//       { _id: "183", name: "Nutrition Coaching" },
//       { _id: "184", name: "Life Coaching" },
//       { _id: "185", name: "Childcare and Babysitting" },
//     ],
//   },
//   {
//     _id: "19",
//     name: "Specialized Services",
//     skills: [
//       { _id: "191", name: "Legal Document Assistance" },
//       { _id: "192", name: "Accounting and Tax Preparation" },
//       { _id: "193", name: "Translation Services" },
//       { _id: "194", name: "Notary Services" },
//       { _id: "195", name: "Health and Wellness Coaching" },
//     ],
//   },
//   {
//     _id: "20",
//     name: "Tailor Services",
//     skills: [
//       { _id: "201", name: "Custom Suit Design" },
//       { _id: "202", name: "Alterations and Repairs" },
//       { _id: "203", name: "Wedding Dress Tailoring" },
//       { _id: "204", name: "Bespoke Shirt Making" },
//       { _id: "205", name: "Embroidery Services" },
//       { _id: "206", name: "Clothing Resizing" },
//       { _id: "207", name: "Curtain and Upholstery Tailoring" }
//     ],
//     icon: TailorIcon,
//     primary: true
//   },
//   {
//     _id: "21",
//     name: "Photography Services",
//     skills: [
//       { _id: "211", name: "Wedding Photography" },
//       { _id: "212", name: "Portrait Photography" },
//       { _id: "213", name: "Event Photography" },
//       { _id: "214", name: "Product Photography" },
//       { _id: "215", name: "Real Estate Photography" },
//       { _id: "216", name: "Aerial and Drone Photography" },
//       { _id: "217", name: "Photo Editing and Retouching" }
//     ],
//     icon: PhotographerIcon,
//     primary: true
//   },
//   {
//     _id: "22",
//     name: "Gardening Services",
//     skills: [
//       { _id: "221", name: "Landscape Design" },
//       { _id: "222", name: "Lawn Maintenance" },
//       { _id: "223", name: "Planting and Transplanting" },
//       { _id: "224", name: "Tree and Shrub Care" },
//       { _id: "225", name: "Weed Control" },
//       { _id: "226", name: "Irrigation System Installation" },
//       { _id: "227", name: "Garden Pest Management" }
//     ],
//     icon: GradeningIcon,
//     primary: true
//   } 
// ];

// NOTE: updated >>>>>>>>>>
export const categories = [
  {
    _id: "1",
    name: "General Handyman Services",
    skills: [
      { _id: "11", name: "Furniture Assembly" },
      { _id: "12", name: "Hanging Pictures and Shelves" },
      { _id: "13", name: "Door Repair" },
      { _id: "14", name: "Lock Replacement" },
      { _id: "15", name: "Basic Carpentry Work" },
      { _id: "16", name: "Window Repair" },
      { _id: "17", name: "Curtain and Blinds Installation" },
      {_id: "18", name: "Tile Installation and Repair" },
      {_id: "19", name: "Drywall Patching and Repair" },
      {_id: "110", name: "Cabinet Installation" },
      {_id: "111", name: "Flooring Installation" },
      {_id: "112", name: "Demolition Support" },
      {_id: "113", name: "Home Organization (closet, kitchen, etc.)" },
      {_id: "114", name: "Appliance Installation and Repairs" },
      {_id: "115", name: "Mounting (TVs, mirrors, shelves)" },
      {_id: "116", name: "Ceiling fan installation " },
    ],
    icon:  handymanIcon,
    primary: true
  },
  {
    _id: "2",
    name: "Plumbing Services",
    skills: [
      { _id: "21", name: "Fixing Leaks and Drips" },
      { _id: "22", name: "Installing Faucets and Showerheads" },
      { _id: "23", name: "Clearing Clogged Drains" },
      { _id: "24", name: "Toilet Repair and Installation" },
      { _id: "25", name: "Water Heater Maintenance" },
    ],
    icon: HandyManServicesIcon,
    primary: true
  },
  {
    _id: "3",
    name: "Electrical Services",
    skills: [
      { _id: "31", name: "Installing Ceiling Fans" },
      { _id: "32", name: "Replacing Light Fixtures" },
      { _id: "33", name: "Electrical Outlet and Switch Repair" },
      { _id: "34", name: "Installing Security Cameras" },
      { _id: "35", name: "Setting Up Home Entertainment Systems" },
    ],
    icon: electricityIcon,
    primary: true
  },
  {
    _id: "4",
    name: "Painting and Decorating",
    skills: [
      { _id: "41", name: "Interior Painting" },
      { _id: "42", name: "Exterior Painting" },
      { _id: "43", name: "Wallpaper Installation and Removal" },
      { _id: "44", name: "Touch-Up Painting" },
      { _id: "45", name: "Furniture Painting" },
    ],
    icon: PaintingIcon,
    primary: true
  },
  {
    _id: "5",
    name: "Cleaning Services",
    skills: [
      { _id: "51", name: "Deep Cleaning (Kitchens, Bathrooms, etc.)" },
      { _id: "52", name: "Carpet Cleaning" },
      { _id: "53", name: "Window Cleaning" },
      { _id: "54", name: "Post-Renovation Clean up" },
      { _id: "55", name: "Garage Cleaning" },
      { _id: "56", name: "Car washing" },
      { _id: "57", name: "Car Detailing" },
      { _id: "58", name: "House cleaning" },
      { _id: "59", name: "Disinfecting services" },
      { _id: "510", name: "Laundry help" },
    ],
    icon: HomeServiceIcon,
    primary: true
  },
  {
    _id: "6",
    name: "Moving Assistance",
    skills: [
      { _id: "61", name: "Packing services" },
      { _id: "62", name: "Unpacking services" },
      { _id: "63", name: "Loading and Unloading Trucks" },
      { _id: "64", name: "Furniture Rearrangement" },
      { _id: "65", name: "Heavy Lifting" },
      {_id: "66", name: "Moving Help" },
      {_id: "67", name: "Heavy Lifting and Moving" },
      {_id: "68", name: "Junk Removal" },
      {_id: "69", name: "Full service movers" },
    ],
    icon: PersonalAssistIcon,
    primary: true
  },
  {
    _id: "7",
    name: "Outdoor Work",
    skills: [
      { _id: "71", name: "Gardening" },
      { _id: "72", name: "Landscaping" },
      { _id: "73", name: "Lawn Mowing" },
      { _id: "74", name: "Maintenance" },
      { _id: "75", name: "Gutter Cleaning" },
      { _id: "76", "name": "Power Washing" },
      { _id: "77", "name": "Fence Repair" },
      { _id: "78", "name": "Fence Installation" },
      { _id: "79", "name": "Tree Trimming" },
      { _id: "710", "name": "Hedge Trimming" }
    ],
    icon: GradeningIcon,
    primary: true
  },
  {
    _id: "8",
    name: "Shopping + Delivery Services",
    skills: [
      { _id: "81", name: "Grocery Shopping and Delivery" },
      { _id: "82", name: "Food Pickup and Delivery" },
      { _id: "83", name: "Courier Services" },
      { _id: "84", name: "Package Delivery" },
      { _id: "85", name: "Furniture or Large Item Delivery" },
      { _id: "86", name: "Errand running" },
    ],
  },
  {
    _id: "9",
    name: "Office and Business Services",
    skills: [
      { _id: "91", name: "Office Cleaning" },
      { _id: "92", name: "Administrative Support" },
      { _id: "93", name: "IT Support (computer setup, troubleshooting)" },
      { _id: "94", name: "Furniture Assembly for Offices" },
      { _id: "95", name: "Business Deliveries" },
    ],
  },
  {
    _id: "10",
    name: "Events and Parties",
    skills: [
      { _id: "101", name: "Catering Assistance" },
      { _id: "102", name: "Bartending" },
      { _id: "103", name: "Party Setup and Clean up" },
      { _id: "104", name: "Event Staffing" },
      { _id: "105", name: "Decorations and Design" },
    ],
  },
  {
    _id: "11",
    name: "Tailors",
    skills: [
      { _id: "1101", name: "Clothing Alteration" },
      { _id: "1102", name: "Wedding dresses" },
      { _id: "1103", name: "Bespoke tailoring" },
    ],
    icon: TailorIcon,
    primary: true
  },
];

export const cities = [
  {
    _id: "1",
    name: "Accra",
    subcities: [
      { _id: "11", name: "Adabraka" },
      { _id: "12", name: "Asylum Down" },
      { _id: "13", name: "Tudu" },
      { _id: "14", name: "North Ridge" },
      { _id: "15", name: "West Ridge" },
      { _id: "16", name: "Ministries" },
      { _id: "17", name: "Ussher Town" },
      { _id: "18", name: "jamestown" },
      { _id: "19", name: "High Street" },
      { _id: "110", name: "Kantamanto" },
      { _id: "111", name: "Labadi (La)" },
      { _id: "112", name: "Cantonments" },
      { _id: "113", name: "Burma Camp" },
      { _id: "114", name: "Trade Fair" },
      { _id: "115", name: "South La" },
      { _id: "116", name: "Airport Residential" },
      { _id: "117", name: "Dzorwulu" },
      { _id: "118", name: "Roman Ridge" },
      { _id: "119", name: "Abelenkpe" },
      { _id: "120", name: "Tesano" },
      { _id: "121", name: "East Legon" },
      { _id: "122", name: "Legon" },
      { _id: "123", name: "Okponglo" },
      { _id: "124", name: "Mempeasem" },
      { _id: "125", name: "Kokomlemle" },
      { _id: "126", name: "New Town" },
      { _id: "127", name: "Kanda" },
      { _id: "128", name: "Alajo" },
      { _id: "129", name: "Kotobabi" },
      { _id: "130", name: "Nima" },
      { _id: "131", name: "Maamobi" },
      { _id: "132", name: "Accra New Town" },
      { _id: "133", name: "Pig Farm" },
      { _id: "134", name: "Kawukudi" },
      { _id: "135", name: "Teshie" },
      { _id: "136", name: "Tebibiano" },
      { _id: "137", name: "Agblezaa" },
      { _id: "138", name: "Tsui Bleoo" },
      { _id: "139", name: "Nungua" },
      { _id: "140", name: "Nungua Estates" },
      { _id: "141", name: "Sakumono Village" },
      { _id: "142", name: "Tema Communities 1-25" },
      { _id: "143", name: "Industrial Area" },
      { _id: "144", name: "Sakumono" },
      { _id: "145", name: "Kpone" },
      { _id: "146", name: "Community 18" },
      { _id: "147", name: "Lashibi" },
      { _id: "148", name: "Baatsona" },
      { _id: "149", name: "Klagon" },
      { _id: "150", name: "Sakumono Estate" },
      { _id: "151", name: "Madina" },
      { _id: "152", name: "Ogbojo" },
      { _id: "153", name: "Teiman" },
      { _id: "154", name: "Adjiriganor" },
      { _id: "155", name: "Ritz Junction" },
      { _id: "156", name: "Adenta" },
      { _id: "157", name: "Frafraha" },
      { _id: "158", name: "Ashiyie" },
      { _id: "159", name: "Amrahia" },
      { _id: "160", name: "Adjiringanor" },
      { _id: "161", name: "Dome" },
      { _id: "162", name: "Kwabenya" },
      { _id: "163", name: "Taifa" },
      { _id: "164", name: "Haatso" },
      { _id: "165", name: "Agbogba" },
      { _id: "166", name: "Amasaman" },
      { _id: "167", name: "Pokuase" },
      { _id: "168", name: "Ofankor" },
      { _id: "169", name: "Medie" },
      { _id: "170", name: "Sarpeiman" },
      { _id: "171", name: "Mayera" },
      { _id: "172", name: "Kotoku" },
      { _id: "173", name: "Sowutuom" },
      { _id: "174", name: "Taifa-Burkina" },
      { _id: "175", name: "Anyaa" },
      { _id: "176", name: "Awoshie" },
      { _id: "177", name: "Chantan" },
      { _id: "178", name: "Lapaz" },
      { _id: "179", name: "Santa Maria" },
      { _id: "180", name: "Weija" },
      { _id: "181", name: "McCarthy Hill" },
      { _id: "182", name: "Bortianor" },
      { _id: "183", name: "Kokrobite" },
      { _id: "184", name: "Tuba" },
      { _id: "185", name: "Gbawe" },
      { _id: "186", name: "Mallam" },
      { _id: "187", name: "New Weija" },
      { _id: "188", name: "Oblogo" },
      { _id: "189", name: "Tetegu" },
      { _id: "190", name: "Abossey Okai" },
      { _id: "191", name: "Kaneshie" },
      { _id: "192", name: "Mataheko" },
      { _id: "193", name: "Lartebiokorshie" },
      { _id: "194", name: "Odorkor" },
      { _id: "195", name: "Darkuman" },
      { _id: "196", name: "Kwashieman" },
      { _id: "197", name: "Awoshie" },
      { _id: "198", name: "Dansoman" },
      { _id: "199", name: "Sahara" },
      { _id: "1100", name: "Opetekwe" },
      { _id: "1101", name: "Russia" },
      { _id: "1102", name: "Osu" },
      { _id: "1103", name: "Ridge" },
      { _id: "1104", name: "Ministries" },
      { _id: "1105", name: "North Ridge" },
      { _id: "1106", name: "Achimota" },
      { _id: "1107", name: "Tesano" },
      { _id: "1108", name: "Apenkwa" },
      { _id: "1109", name: "Alogboshie" },
      { _id: "1110", name: "Bubiashie" },
      { _id: "1111", name: "Kaneshie" },
      { _id: "1112", name: "Awudome" },
      { _id: "1113", name: "North Kaneshie" },
      { _id: "1114", name: "Dodowa" },
      { _id: "1115", name: "Agormanya" },
      { _id: "1116", name: "Doryumu" },
      { _id: "1117", name: "Prampram" },
      { _id: "1118", name: "Ningo" },
      { _id: "1119", name: "Dawhenya" },
      { _id: "1120", name: "Kpone" },
      { _id: "1121", name: "Katamanso" },
      { _id: "1122", name: "Santeo" },
      { _id: "1123", name: "Gbetsile" },
      { _id: "1124", name: "Ada Foah" },
      { _id: "1125", name: "Big Ada" },
      { _id: "1126", name: "Kasseh" },
      { _id: "1127", name: "Sege" },
      { _id: "1128", name: "Anyamam" },
      { _id: "1129", name: "Goi" },
    ],
  },
  {
    _id: "2",
    name: "Kumasi",
    subcities: [
      { _id: "21", name: "Bantama" },
      { _id: "22", name: "Suame" },
      { _id: "23", name: "Oforikrom" },
      { _id: "24", name: "Asokwa" },
      { _id: "25", name: "Kwadaso" },
      { _id: "26", name: "Ejisu" },
      { _id: "27", name: "Manhyia" },
    ],
  },
  {
    _id: "3",
    name: "Sekondi-Takoradi",
    subcities: [
      { _id: "31", name: "Effia" },
      { _id: "32", name: "Kwesimintsim" },
      { _id: "33", name: "Shama" },
      { _id: "34", name: "Agona Nkwanta" },
    ],
  },
  {
    _id: "4",
    name: "Cape Coast",
    subcities: [
      { _id: "41", name: "Elmina" },
      { _id: "42", name: "Mankessim" },
      { _id: "43", name: "Kasoa" },
      { _id: "44", name: "Saltpond" },
    ],
  },
  {
    _id: "5",
    name: "Koforidua",
    subcities: [
      { _id: "51", name: "New Juaben" },
      { _id: "52", name: "Nsawam" },
      { _id: "53", name: "Aburi" },
      { _id: "54", name: "Suhum" },
    ],
  },
  {
    _id: "6",
    name: "Tamale",
    subcities: [
      { _id: "61", name: "Sagnarigu" },
      { _id: "62", name: "Yendi" },
      { _id: "63", name: "Savelugu" },
    ],
  },
  {
    _id: "7",
    name: "Ho",
    subcities: [
      { _id: "71", name: "Keta" },
      { _id: "72", name: "Hohoe" },
      { _id: "73", name: "Aflao" },
    ],
  },
  {
    _id: "8",
    name: "Bolgatanga",
    subcities: [
      { _id: "81", name: "Bawku" },
      { _id: "82", name: "Navrongo" },
    ],
  },
  {
    _id: "9",
    name: "Wa",
    subcities: [
      { _id: "91", name: "Nadowli" },
      { _id: "92", name: "Tumu" },
    ],
  },
  {
    _id: "10",
    name: "Sunyani",
    subcities: [
      { _id: "101", name: "Berekum" },
      { _id: "102", name: "Dormaa Ahenkro" },
    ],
  },
  {
    _id: "11",
    name: "Goaso",
    subcities: [
      { _id: "111", name: "Hwidiem" },
      { _id: "112", name: "Mim" },
    ],
  },
  {
    _id: "12",
    name: "Techiman",
    subcities: [
      { _id: "121", name: "Kintampo" },
      { _id: "122", name: "Nkoranza" },
    ],
  },
  {
    _id: "13",
    name: "Damongo",
    subcities: [
      { _id: "131", name: "Bole" },
      { _id: "132", name: "Salaga" },
    ],
  },
  {
    _id: "14",
    name: "Nalerigu",
    subcities: [
      { _id: "141", name: "Walewale" },
      { _id: "142", name: "Gambaga" },
    ],
  },
  {
    _id: "15",
    name: "Sefwi Wiawso",
    subcities: [
      { _id: "151", name: "Bibiani" },
      { _id: "152", name: "Enchi" },
    ],
  },
  {
    _id: "16",
    name: "Dambai",
    subcities: [
      { _id: "161", name: "Kete Krachi" },
      { _id: "162", name: "Nkwanta" },
    ],
  },
];

// INFO: Paystack Mobile Money Providers in Ghana
export const mobileMoneyProviders = [
  {
    _id: "mtn",
    name: "MTN Mobile Money (MTN MoMo)",
  },
  {
    _id: "atl",
    name: "AirtelTigo Money",
  },
  {
    _id: "vod",
    name: "Vodafone Cash",
  },
];

// INFO: Ghana Banks
export const banks = [
  { _id: "1", name: "GCB Bank" },
  { _id: "2", name: "Absa Bank Ghana" },
  { _id: "3", name: "Stanbic Bank Ghana" },
  { _id: "4", name: "Ecobank Ghana" },
  { _id: "5", name: "Fidelity Bank Ghana" },
  { _id: "6", name: "CalBank" },
  { _id: "7", name: "Zenith Bank Ghana" },
  { _id: "8", name: "Access Bank Ghana" },
  { _id: "9", name: "Republic Bank Ghana" },
  { _id: "10", name: "First National Bank Ghana" },
  { _id: "11", name: "United Bank for Africa (UBA) Ghana" },
  { _id: "12", name: "Societe Generale Ghana" },
  { _id: "13", name: "Guaranty Trust Bank (GTBank) Ghana" },
  { _id: "14", name: "Standard Chartered Bank Ghana" },
  { _id: "15", name: "First Atlantic Bank" },
  { _id: "16", name: "Consolidated Bank Ghana (CBG)" },
  { _id: "17", name: "OmniBSIC Bank" },
  { _id: "18", name: "Universal Merchant Bank (UMB)" },
  { _id: "19", name: "Prudential Bank" },
  { _id: "20", name: "National Investment Bank (NIB)" },
];

// INFO: complaint reasons types
export const complaintReasons = [
  { _id: "1", reason: "Incomplete cleaning" },
  { _id: "2", reason: "Damaged property" },
  { _id: "3", reason: "Late arrival" },
  { _id: "4", reason: "Unprofessional behavior" },
  { _id: "5", reason: "Plants damaged" },
  { _id: "6", reason: "Incomplete work" },
  { _id: "7", reason: "Tools left behind" },
  { _id: "8", reason: "Overcharged" },
  { _id: "9", reason: "Leaking pipes after service" },
  { _id: "10", reason: "Incomplete repair" },
  { _id: "11", reason: "Wrong part used" },
];

// INFO: complaint resolving reasons types
export const complaintResolvingReasons = [
  { _id: "1", name: "Incomplete cleaning" },
  { _id: "2", name: "Damaged property" },
  { _id: "3", name: "Late arrival" },
  { _id: "4", name: "Unprofessional behavior" },
  { _id: "5", name: "Plants damaged" },
  { _id: "6", name: "Incomplete work" },
  { _id: "7", name: "Tools left behind" },
  { _id: "8", name: "Overcharged" },
  { _id: "9", name: "Leaking pipes after service" },
  { _id: "10", name: "Incomplete repair" },
  { _id: "11", name: "Wrong part used" },
];

export const paymentTypes = {
  BANK: 'BANK',
  MOBILE_MONEY: 'MOBILE_MONEY',
}

export const paymentMetrics = {
  taskerCommision: 80, // 80%
  clientFee: 6, // 6%
  boundaryAmount: 200, // GHS
  minimumAmount: 30, // GHS
  flatFee: 20, // GHS
}

export const clientQuestions = [
  {
    question: 'How do I post a task?',
    answer:
      'Simply create an account, click “Post a Job,” describe the task, choose a category, set your location and budget, then submit.'
  },
  {
    question: 'How do I choose the right service provider?',
    answer:
      'You can review tasker profiles, ratings, and reviews before hiring.'
  },
  {
    question: 'Can I schedule a task in advance?',
    answer:
      'Yes! You can choose a future date and time when posting your job.'
  },
  {
    question: 'How do I pay for a task?',
    answer:
      'You’ll pay securely through the app using Mobile Money or card. Payment is held until the job is completed and confirmed.'
  },
  {
    question: 'What if the task is not completed properly?',
    answer:
      'We offer a resolution process where you can dispute the task before payment is released.'
  },
  {
    question: 'Are the taskers verified?',
    answer:
      'Yes. All taskers go through an ID verification process.'
  }
];

export const taskerQuestions = [
  {
    question: 'How do I sign up as a tasker?',
    answer:
      'Go onto the website, select “Sign up as a service Pro,” fill in your profile, choose your skills, and upload your ID for verification.'
  },
  {
    question: 'How are taskers verified?',
    answer:
      'Taskers must submit valid national ID and a selfie which is verified using a third party.'
  },
  {
    question: 'How do I find jobs?',
    answer:
      'Go to the Jobs tab, use the filters (location, category, budget), and apply for jobs you are qualified for.'
  },
  {
    question: 'Do I have to pay to get jobs?',
    answer:
      'No. Jumaconnect is free to use. A small commission is deducted only when you complete a job successfully.'
  },
  {
    question: 'Can I set my service area?',
    answer:
      'Yes! You can choose your suburb or select city if you are willing to travel for jobs.'
  },
  {
    question: 'How do I get paid?',
    answer:
      'Once the job is completed and confirmed by the client, your payment will be processed and sent to your Mobile Money or bank account.'
  },
  {
    question: 'Can I decline a job?',
    answer:
      'Yes. You are free to accept or decline any job that doesn’t suit you.'
  },
  {
    question: 'How do I improve my profile?',
    answer:
      'Complete your profile, add certifications, respond quickly to clients, post photos of completed jobs and complete jobs with a quality finish to earn better ratings and reviews.'
  }
];

export const generalQuestions = [
  {
    question: 'What is Jumaconnect?',
    answer:
      'Jumaconnect is a platform that connects clients with service providers (taskers) across Accra and Ghana for tasks like plumbing, electrical work, cleaning, and many more.'
  },
  {
    question: 'Is Jumaconnect free to use?',
    answer:
      'Yes! Signing up and using the platform is free. Fees are only charged when a job is booked and successfully completed.'
  },
  {
    question: 'Which locations do you operate in?',
    answer:
      'We are currently available in Accra, with plans to expand across Ghana soon.'
  },
  {
    question: 'Is payment safe?',
    answer:
      'Yes. All payments are processed through a secure system and held until the task is completed and confirmed by client.'
  },
  {
    question: 'How do I contact support?',
    answer:
      'You can reach us via WhatsApp live chat, email, or our support form.'
  },
];